import isMwebUrl from 'shared_js/helpers/urlHelper/isMwebUrl';

const { Tracker } = window;

if (Tracker) {
  Tracker.config({
    baseUrl: process.env.TRACKER_BASE_URL,
    dev: process.env.NODE_ENV !== 'production',
    platform: isMwebUrl() ? 'mobile' : 'desktop',
  });
}

export default Tracker;
